import { createContext } from "react";

// Leaving the payment/analysis chain (for example, opening a merchant) dismisses
// its ancestors too, so the destination is not hidden behind an earlier dialog.
export const TransactionNavigationContext = createContext<(() => void) | undefined>(undefined);
